export default [
  {
    path: "/organizations/:organizationId/investigations",
    props: true,
    component: () => import("@/views/reports/investigations/ListInvestigations.vue"),
    meta: {
      authorization: {
        features: ["investigations"],
        role: ["organization-administrator", "investigation-summary", "investigation-creator", "investigation-viewer", "investigation-proctor"],
      },
    },
  },
  {
    path: "/organizations/:organizationId/investigations/create",
    props: true,
    component: () => import("@/views/reports/investigations/CreateInvestigation.vue"),
    meta: {
      authorization: {
        features: ["investigations"],
        role: ["organization-administrator", "investigation-creator"],
      },
    },
  },
  {
    path: "/organizations/:organizationId/investigations/:investigationId",
    props: true,
    component: () => import("@/views/reports/investigations/EditInvestigation.vue"),
    meta: {
      authorization: {
        features: ["investigations"],
        role: ["organization-administrator", "investigation-creator", "investigation-viewer", "investigation-proctor"],
      },
    },
  },
];
